const maxNumberOfIPAddress = 5;

export const variables = {
  maxNumberOfIPAddress,
};
